import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, rydeColors } from "@ryde/theme";

export const RideBoardingIndicatorStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-boarding-indicator",
  },
)`
  line-height: 0;
  & > span {
    vertical-align: middle;
    line-height: 0;
  }
  svg {
    color: ${blueGreyMui._300};
  }
`;

export const RideSearchRouteIterationIndicatorWrapper = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-search-route-iteration-indicator",
  },
)`
  display: inline-flex;
  align-items: center;
  color: ${rydeColors.orange};
  margin-inline-start: 4px;

  svg {
    font-size: 18px;
  }
`;
